'use strict';

const _ = require('lodash');
const Classnames = require('classnames');
const ReactRouter = require('react-router');
const React = require('react');

const Link = ReactRouter.Link;

const Constants = require('../../constants');
const DeviceImage = require('../../global/device-image.jsx');

const isNode = typeof document === 'undefined';

if (!isNode) {
    const requestAnimationFrame = require('requestanimationframe');
    require('./moma.scss');
}

const DEBUG_INDEX = false;

const INSET = 120;  // Total width of pane inset (twice arrow png width)

var Moma = {
    propTypes: {
        // Array of objects passed to slideContent() of mixing-in class.
        // Each object must include properties:
        //   - width (int)
        //   - height (int)
        //   - id (used for React key attributes)
        gallery: React.PropTypes.arrayOf(React.PropTypes.shape({
            width: React.PropTypes.number,
            height: React.PropTypes.number,
            id: React.PropTypes.oneOfType([ React.PropTypes.string, React.PropTypes.number ]),
        })).isRequired,

        spec: React.PropTypes.shape({
            desktop: React.PropTypes.shape({
                position:   React.PropTypes.oneOf([ 'inside', 'outside' ]),
                graphic:    React.PropTypes.oneOf([ 'solid', 'mid', 'light' ]),
                navigation: React.PropTypes.oneOf([ 'hero', 'focused', 'paged' ]),
            }),
            mobile: React.PropTypes.shape({
                position:   React.PropTypes.oneOf([ 'inside', 'outside' ]),
                graphic:    React.PropTypes.oneOf([ 'solid', 'mid', 'light', 'simple' ]),
                navigation: React.PropTypes.oneOf([ 'hero', 'focused', 'paged' ]),
            }),
        }).isRequired,

        padding: React.PropTypes.number,

        scrolltime: React.PropTypes.number,

        loop: React.PropTypes.bool,

        // For Collections-type gallery where many slides exist on a page, this controls size of 
        // page relative to container width (1 = container width) - paging for variable-width slides
        pageSize: React.PropTypes.number,

        // Fixed pixel value to add to track & pane height - used for homepage video gallery captions
        additionalHeight: React.PropTypes.number,

        // Initial start index - used to preserve GroupItems scroll position on Product Detail page after zooming image photo
        index: React.PropTypes.object, // LinkedState

        ident: React.PropTypes.string, // label to help debug when multiple galleries on page
    },
    getDefaultProps: function() {
        return {
            padding: 6,
            loop: true,
            scrolltime: 300,
            pageSize: 1,
            colorTheme: 'light',
            index: null,
        };
    },
    getInitialState: function() {
        return {
            // containerSize: null,

            // Page index
            ix: this.props.index ? this.props.index.value : 0,
            cachedIx: 0,

            // Interpolation: /x/ is positive pixel value along track
            // (so track is rendered at -x)
            currentX: 0,
            startX: 0,
            endX: 0,

            startTime: Date.now(),
            endTime: Date.now()
        };
    },

    slides: [],
    trackWidth: null,
    pages: null,

    // Set to false if pageSize < 1 (Product Detail page) and only one page exists
    drawArrows: true,  

    debug: function(msg) {
        //log(`${this.props.ident} - ${msg}`);
    },

    getSpec: function() {
        if (this.state.viewportLayout == 'desktop' || !this.props.spec.mobile) {
            return this.props.spec.desktop;
        } else {
            return this.props.spec.mobile;
        }
    },

    // Dimensions
    //
    // Used to give width & height to Moma DOM element
    // and to calculate offsets by runLayoutCalculations()
    //
    // Desktop - fixed width - width and height are used
    // Mobile - variable width - fit to width of window, adjust height to keep aspect ratio
    getContainerSize: function() {
        const assetSizes = this.AssetSizes(),
              w = this.state.viewportWidth,
              h = this.state.viewportHeight;

        if (this.state.viewportLayout == 'portrait') {
            return {
                width: w,
                height: w / Constants.Breaks.MobilePortraitMax * assetSizes.mobile.portrait.height,
            };
        }
        else if (this.state.viewportLayout == 'landscape') {
            return {
                width: w,
                height: w / Constants.Breaks.MobileLandscapeMax * assetSizes.mobile.landscape.height,
            };
        }
        else {
            if (assetSizes.desktop) {
                return {
                    width: assetSizes.desktop.width,
                    height: assetSizes.desktop.height,
                }
            } else {
                // When transitioning from mobile layout to desktop, ItemTabMomaGallery can render when not mounted
                // Note ItemTabMomaGallery.AssetSizes has no /desktop/, so guard and return null in Moma.render().
                return null;
            }
        }
    },
    componentDidMount: function() {
        this.runLayoutCalculations();

        let x = this.xForPage(this.state.ix);
        this.setState({
            currentX: x,
        });
    },
    componentWillUpdate: function(nextProps) {
        // Recalculate all coords when gallery content changes
        this.runLayoutCalculations(nextProps);
    },
    componentDidResize: function() {  // /Responsive/ mixin
        this.state.cachedIx = null;
        this.forceUpdate();
    },
    componentDidUpdate: function(prevProps, prevState) {

        // Update when provided index (e.g. from URL) changes e.g. prod detail's <SeriesItems>
        if (this.getSpec().navigation == 'focused') {
            if (prevProps.index && this.props.index.value != prevProps.index.value) {
                this.state.ix = this.props.index.value;
            }
        }

        // When gallery changes, need to recalculate layout
        if (JSON.stringify(prevProps.gallery) !== JSON.stringify(this.props.gallery)) {
            this.runLayoutCalculations();
            this.state.cachedIx = null;
            this.state.ix = 0;
        }

        // The invariant /state.ix != state.cachedIx/ is true when new content needs to be loaded (state.ix changes)
        if (this.state.ix != this.state.cachedIx)
        {
            const endX = this.xForPage(this.state.ix);

            this.state.cachedIx  = this.state.ix;
            this.state.startTime = Date.now();
            this.state.endTime   = Date.now() + this.props.scrolltime;
            this.state.startX    = this.state.currentX;
            this.state.endX      = endX;

            requestAnimationFrame(this.tick);
        }
    },
    tick: function() {
        var now = Date.now();
        if (now < this.state.endTime)
        {
            var p = (now - this.state.startTime) / (this.state.endTime - this.state.startTime);
            p = p * (2 - p);  // Penner out quad easing

            var d = this.state.endX - this.state.startX;
            this.state.currentX = this.state.startX + (p * d);

            requestAnimationFrame(this.tick);
        }
        else
        {
            this.state.currentX = this.state.endX;
        }
        this.forceUpdate();
    },

    // Returns left edge of page /ix/ using precalculated coords
    xForPage: function(ix) {
        let endX;

        const containerSize = this.getContainerSize();

        switch (this.getSpec().navigation) {
            case 'hero':  // center on the slide
            {
                const o = this.slides[ix];
                endX = -o.left + (containerSize.width - o.width) / 2;
                break;
            }
            case 'paged':  // left-edge already computed
                endX = -this.pages[ix];
                break;

            case 'focused':  // center on the focused slide
            {
                if (this.trackWidth > containerSize.width) {
                    const o = this.slides[ix];
                    endX = -o.left + (containerSize.width - o.width - INSET) / 2;
                    endX = Math.min(0, endX);
                    endX = Math.max(-this.trackWidth + containerSize.width - INSET, endX);
                } else {
                    let t = containerSize.width - INSET;
                    endX = (t - this.trackWidth) / 2;
                }
                break;
            }
        }

        return endX;
    },

    // Called from componentDidUpdate so don't store anything in state here
    runLayoutCalculations: function(nextProps) {
        const props = nextProps ? nextProps : this.props;

        let containerSize = this.getContainerSize();

        if (this.getSpec().position == 'outside') {
            containerSize.width = containerSize.width - INSET;
        }

        this.slideCalculations(props, containerSize);

        if (this.trackWidth < this.getContainerSize().width) {
            containerSize = this.getContainerSize();
        }

        if (this.getSpec().navigation == 'paged') {
            this.pageCalculations(props, containerSize);
        }
    },

    // Calculates x offset of each slide in track (/x/ is left edge of slide), and total width of track
    slideCalculations: function(props, containerSize) {
        const slides = [];
        let x = 0;

        props.gallery.forEach((slide, ix) => {
            let aspect,
                w;
            if (slide.width && slide.height) {
                aspect = slide.width / slide.height;
                w = slide.width;
            } else {
                aspect = containerSize.width / containerSize.height;
                w = containerSize.width;
            }
            if (w > containerSize.width) {
                w = containerSize.width;
            }
            let h = w * (1/aspect);
            if (h > containerSize.height) {
                h = containerSize.height;
                w = h * aspect;
            }

            x = Math.round(x);
            w = Math.round(w);
            h = Math.round(h);

            // This is /meta/ as passed to slideContent(slide, meta):
            const meta = {
                id: slide.id,
                left:   x,
                right:  x + w,
                width:  w,
                height: h,
            };

            slides.push(meta);

            x += meta.width + props.padding;
        });

        this.slides = slides;
        this.trackWidth = x - props.padding;

        if (this.trackWidth < this.getContainerSize().width) {
            this.drawArrows = false;
        }
    },

    // Calculate optimum page widths to cover all slides without obscuring by arrows
    pageCalculations: function(props, containerSize) {
        let c_w = containerSize.width;

        if (this.getSpec().position == 'inside') {
            c_w -= INSET;
        }

        const pages = [];
        let stack = [];

        const stackWidth = stack => {
            return stack[stack.length-1].right - stack[0].left;
        };

        this.slides.forEach(slide => {
            stack.push(slide);

            if (stackWidth(stack) > c_w) {
                const carry = stack.pop(),
                      center = stack[0].left + stackWidth(stack) / 2;
                let px = center - c_w / 2;

                if (this.getSpec().position == 'inside') {
                    px -= INSET / 2;
                }

                pages.push(Math.max(px, 0));
                stack = [ carry ];
            }
        });

        let x = 0;
        if (this.trackWidth > c_w) {
            // Right-align the last page
            x = stack[stack.length - 1].right - c_w;
            if (this.getSpec().position == 'inside') {
                 x -= INSET;
            }
            this.drawArrows = true;
        } else {
            // Or center if the only page
            let t = c_w;
            if (this.getSpec().position == 'inside') {
                t += INSET;
            }
            x = -(t - this.trackWidth) / 2;
            this.drawArrows = false;
        }
        pages.push(x);

        this.pages = pages;
    },

    // Navigation
    //
    prevClick: function() {
        this.stopAutoplay();
        this.previous();
    },
    nextClick: function() {
        this.stopAutoplay();
        this.next();
    },
    previous: function() {
        if (this.state.ix > 0)
        {
            this.navigateTo(this.state.ix - 1);
        }
        else if (this.props.loop)
        {
            const limit = (this.getSpec().navigation == 'paged' ? this.pages.length
                                                                : this.slides.length) - 1;

            this.navigateTo(limit);
        }
    },
    next: function() {
        const limit = (this.getSpec().navigation == 'paged' ? this.pages.length
                                                            : this.slides.length) - 1;
        if (this.state.ix < limit)
        {
            this.navigateTo(this.state.ix + 1);
        }
        else if (this.props.loop)
        {
           this.navigateTo(0);
        }
    },
    /* ix is 0-based */
    navigateTo(ix) {
        this.setState({ ix: ix });

        // Report new index if containing component needs
        if (this.props.index) {
            this.props.index.requestChange(ix);
        }

        // Homepage stop autoplay
        if (this.slideWillChange) {
            this.slideWillChange(ix, this.props.gallery[ix]);
        }
    },
    keyDown: function(ev) {
        if (ev.keyCode == 37) this.prevClick();
        if (ev.keyCode == 39) this.nextClick();
    },

    // Autoplay
    //
    startAutoplay: function(seconds) {
        this.autoplay_secs = seconds;
        this.interval = setInterval(() => {
            this.next();
        }, seconds * 1000);
    },
    stopAutoplay: function() {
        if (this.interval) {
            clearInterval(this.interval);
        }
    },
    renderTrack: function() {
        var pre,
            post;

        if (this.props.gallery.length != this.slides.length) {
            return <div />;
        }

        const containerSize = this.getContainerSize();

        // "Shadow" slides
        if (this.getSpec().navigation == 'hero' && this.props.gallery.length > 1)
        {
            var data = this.props.gallery[/*this.props.gallery.length -*/ 1];
            var o = this.slides[/*this.slides.length -*/ 1];
            var style = {
                left: this.slides[0].left - o.width - this.props.padding,
                top: (containerSize.height - o.height) / 2,
                width: o.width,
                height: o.height,
            };
            pre = (
                <div className='moma-slide' key={data.id} style={style}>
                    {this.slideContent(data)}
                    <div className='moma-mask'></div>
                </div>
            );

            var data = this.props.gallery[0];
            var o = this.slides[0];
            var style = {
                left: this.slides[this.slides.length-1].left + this.slides[this.slides.length-1].width + this.props.padding,
                top: (containerSize.height - o.height) / 2,
                width: o.width,
                height: o.height,
            };
            post = (
                <div className='moma-slide' key={data.id} style={style}>
                    {this.slideContent(data)}
                    <div className='moma-mask'></div>
                </div>
            );
        }

        var slides = this.props.gallery.map((slide, ix) => {
            let meta = this.slides[ix];
            let style = {
                left: meta.left,
                top: (containerSize.height - meta.height) / 2,
                width: meta.width,
                height: meta.height,
            };
            const classes = Classnames({
                'moma-slide': true,
                'moma-focus': this.getSpec().navigation == 'focused' && ix == this.state.ix,
            });
            return (
                <div className={classes} key={slide.id} style={style}>

                    {this.slideContent(slide, meta)  /* Client callback for slide render */}

                    {DEBUG_INDEX ? <div className='moma-annotation'> {ix}/{slide.id} </div> : null}
                </div>
            );
        });

        var trackStyle = {
            left: this.state.currentX,
        };

        return (
            <div className='moma-track nosel' style={trackStyle}>
                {pre}
                {slides}
                {post}
            </div>
        );
    },
    render: function() {
        var prev, next, track, navigation;
        
        var momaStyle;

        const containerSize = this.getContainerSize();

        if (containerSize == null && this.props.gallery.length) {
            // server rendering but works for first browser rendering too so server and browser both start the same
            track = this.slideContent(this.props.gallery[0]);
        } else {
            track = this.renderTrack();

            navigation = <Navigation spec             = {this.getSpec()}
                                     colorTheme       = {this.props.colorTheme}
                                     additionalHeight = {this.props.additionalHeight}
                                     prevClick        = {this.prevClick}
                                     nextClick        = {this.nextClick}
                                     viewportLayout   = {this.state.viewportLayout} 
                                     
                                     gallery = {this.props.gallery}
                                     ix = {this.state.ix} />

            momaStyle = this.getContainerSize();

            if (!momaStyle) {
                return null;
            }

            if (this.props.additionalHeight) {
                momaStyle.height += this.props.additionalHeight;
            }
        }

        var paneStyle = {};
        if (this.getSpec().position == 'outside' && this.drawArrows) {
            paneStyle.width = this.getContainerSize().width - INSET;
        }

        return (
            <div className='moma' style={momaStyle}>
                <div className='moma-pane' style={paneStyle}>
                    {track}
                </div>
                {this.drawArrows ? navigation : null}
            </div>
        );
    }
};

var Navigation = React.createClass({
    propTypes: {
        // keep in sync with Moma propTypes
        spec: React.PropTypes.object,
        colorTheme: React.PropTypes.oneOf(['dark', 'light']).isRequired,
        additionalHeight: React.PropTypes.number,
        prevClick: React.PropTypes.func,
        nextClick: React.PropTypes.func,
        viewportLayout: React.PropTypes.string,
    },
    render: function() {
        const graphic = this.props.spec.graphic;
        const position = this.props.spec.position;

        const prevFile = `nav-${graphic}-left`;
        const nextFile = `nav-${graphic}-right`;

        const leftClasses = {
            'nosel': true,
            'moma-left': true,
            'moma-inset': position == 'outside',
            'moma-solid': graphic != 'simple',
            'moma-simple': graphic == 'simple',
        };
        const rightClasses = Object.assign({}, leftClasses, {
            'moma-left': false,
            'moma-right': true,
        });

        const navStyle = {};
        if (this.props.additionalHeight) {
            navStyle.bottom = this.props.additionalHeight;
        }

        let leftImg,
              rightImg;
        if (graphic != 'simple') {
            leftImg  = ( <DeviceImage src={`moma/${prevFile}.png`} alt='previous' width={'21'} height={'53'} /> );
            rightImg = ( <DeviceImage src={`moma/${nextFile}.png`} alt='next' width={'21'} height={'52'} /> );
        } else {
            leftImg  = ( <img className="left-arrow" src={`${Payload.static}/images/moma/${prevFile}.png`} width='70' height='90' alt='prev' /> );
            rightImg = ( <img className="right-arrow" src={`${Payload.static}/images/moma/${nextFile}.png`} width='70' height='90' alt='next' /> );
        }

        const G       = this.props.gallery,
              L       = G.length - 1,
              ix      = this.props.ix,
              prevURL = ( ix > 0 ? G[ix - 1] : G[L] ).url,
              nextURL = ( ix < L ? G[ix + 1] : G[0] ).url;

        if (this.props.spec.navigation == 'focused') {
            return (
                <div>
                    <div className='moma-nav'>
                        <Link to={prevURL} state={{ scroll: false }} className={Classnames(leftClasses)} style={navStyle}>
                            {leftImg}
                        </Link>
                    </div>
                    <div className='moma-nav'>
                        <Link to={nextURL} state={{ scroll: false }} className={Classnames(rightClasses)} style={navStyle}>
                            {rightImg}
                        </Link>
                    </div>
                </div>
            );
        } else {
            return (
                <div>
                    <div className='moma-nav'>
                        <div onClick={this.props.prevClick} className={Classnames(leftClasses)} style={navStyle}>
                            {leftImg}
                        </div>
                    </div>
                    <div className='moma-nav'>
                        <div onClick={this.props.nextClick} className={Classnames(rightClasses)} style={navStyle}>
                            {rightImg}
                        </div>
                    </div>
                </div>
            );
        }
    }
});

module.exports = Moma;



// WEBPACK FOOTER //
// ./src/plugins/moma/moma.jsx